/**
 * `/cohort/:jobId?c=<criterion>` — the cohort review queue as a tab page.
 * Reports the finished run to the shell (`reportRun`) so CEPI can offer it;
 * nothing attaches until the user chooses to.
 */
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import CohortResultQueue from '../components/CohortResultQueue';
import { useTab } from './TabContext';

export const CohortPage: React.FC = () => {
  const { jobId } = useParams();
  const [params] = useSearchParams();
  const { reportRun } = useTab();
  if (!jobId) return null;
  return (
    // Keyed so a route change to another job remounts it and that run reports too.
    <CohortResultQueue key={jobId} jobId={jobId} criterion={params.get('c') ?? undefined}
      onRunComplete={(r) => reportRun({ kind: 'job', ...r })}
    />
  );
};

export default CohortPage;
